// 社員側の画面テーマを、スマートフォン（OS）のダークモード設定に追従させる。
// 表示は持たない（切替UIなし）。HelpToggle と同じく EmployeeRoute に1箇所置けば全画面に効く。
//
// ダーク配色が未整備の画面にダークを当てると、白背景×白文字などで読めなくなるため、
// 適用対象は src/lib/theme.js の DARK_READY_PATHS に載っている画面だけに限定している。
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { prefersDark, applyTheme, subscribeSystemTheme, isDarkReadyPath } from "../lib/theme";

export default function ThemeSync() {
  const { pathname } = useLocation();
  const [systemDark, setSystemDark] = useState(prefersDark);

  // OS 側でダーク／ライトを切り替えたら即座に反映する
  useEffect(() => subscribeSystemTheme(setSystemDark), []);

  useEffect(() => {
    applyTheme(systemDark, isDarkReadyPath(pathname));
  }, [systemDark, pathname]);

  // 社員画面から離れるとき（管理画面へ遷移など）は必ずライトへ戻す
  useEffect(() => () => applyTheme(false, false), []);

  return null;
}
